import { GlCard, GlSkeletonLoader, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'TimeboxSummaryCards',
    cardBodyClass: 'gl-text-center gl-py-3 gl-text-size-h2',
    cardClass: 'gl-border-0 gl-mb-5',
    components: {
        GlCard,
        GlSkeletonLoader,
        GlSprintf
    },
    props: {
        columns: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        loading: {
            type: Boolean,
            required: true
        },
        total: {
            type: Number,
            required: true
        }
    },
    methods: {
        percent (val) {
            if (!this.total) return 0;
            return (val / this.total * 100).toFixed(0);
        }
    }
};
